var v1="<div gnp-select-club-list=\"\" on-club-selected=\"selectClub()\" on-load-club=\"loadClub\" preload=\"true\" is-history=\"true\" style=\"margin-top: 24px\"><div ng-show=\"isSearched()\" class=\"span-12\"><p ng-show=\"hasNoResult\">{{:: '_SCORE_REGISTRATION.SELECT_CLUB_HISTORY.NORESULT' | translate }}</p></div></div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("score-registration/select-club/history.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/score-registration/select-club/history.jade
// module id = 432
// module chunks = 0